import { create } from "zustand";

// Whether the input bar's "+" tray is open, so the panel content behind it can fade.
interface ComposerTrayStore {
    isTrayOpen: boolean;
    setTrayOpen: (isTrayOpen: boolean) => void;
}

export const useComposerTrayStore = create<ComposerTrayStore>()(set => ({
    isTrayOpen: false,
    setTrayOpen: isTrayOpen => set({ isTrayOpen })
}));
